<aside class="page-aside" style="min-width:14rem;padding:0 var(--wa-spacing-large) var(--wa-spacing-large) var(--wa-spacing-large);position:sticky;top:var(--wa-spacing-large);">
	<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>On this page</div>
	<ul style="display:flex;flex-direction:column;gap:var(--wa-spacing-x-small);list-style:none;margin:var(--wa-spacing-small) 0 0 0;padding:0;">
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('architecture').scrollIntoView({behavior:'smooth'})">Overview</a>
		</li>
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('stack').scrollIntoView({behavior:'smooth'})">Stack Diagram</a>
		</li>
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('build-pipeline').scrollIntoView({behavior:'smooth'})">Build Pipeline</a>
		</li>
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('runtime').scrollIntoView({behavior:'smooth'})">Runtime</a>
		</li>
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('data-flow').scrollIntoView({behavior:'smooth'})">Data Flow</a>
		</li>
		<li>
			<a href="javascript:void(0)" onclick="document.getElementById('module-graph').scrollIntoView({behavior:'smooth'})">Module Graph</a>
		</li>
	</ul>
</aside>